import {convertToCelsius, convertToFahrenheit} from '../../Units';

export default (T: number, RH: number) => {
  const TF = convertToFahrenheit(T);
  let heatIndexInFahrenheit =
    -42.379 +
    2.04901523 * TF +
    10.14333127 * RH -
    0.22475541 * TF * RH -
    0.00683783 * TF * TF -
    0.05481717 * RH * RH +
    0.00122874 * TF * TF * RH +
    0.00085282 * TF * RH * RH -
    0.00000199 * TF * TF * RH * RH;

  let adjustment = 0;
  if (RH < 13 && TF > 80 && TF < 112) {
    adjustment = ((13 - RH) / 4) * Math.sqrt((17 - Math.abs(TF - 95.0)) / 17);
  } else if (RH > 85 && TF > 80 && TF < 87) {
    adjustment = ((RH - 85) / 10) * ((87 - TF) / 5);
  } else {
    heatIndexInFahrenheit = 0.5 * (TF + 61.0 + (TF - 68.0) * 1.2 + RH * 0.094);
  }
  return convertToCelsius(heatIndexInFahrenheit - adjustment);
};
